import { FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@bikes/routes/Routes';
import { BikesType } from '@bikes/store/storeSlices/bikesDetails';
import { useBikesStore } from '@bikes/store/store';
import { BinaryQuestionTemplate } from '@templates';
import { ErrorMessages } from '@types';
import {
  HireBikesSlaTexts,
  HireScootersSlaTexts,
} from '@bikes/constants/slaTexts';

export const IssueDetails: FunctionComponent = () => {
  const navigate = useNavigate();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  const { bikesType, obstructionType, updateObstructionType, updateSlaText } =
    useBikesStore();

  const title = 'What is the issue?';
  const errorPath = 'radio';
  const context = bikesType === 'hire_bikes' ? 'Bike' : 'Scooter';

  const options = [
    {
      id: 'ParkedDangerously',
      name: 'ParkedDangerously',
      labelText: `${context} is parked dangerously and might hurt someone`,
      subtext: '',
      buttonRef: null,
    },
    {
      id: 'BlockingCrossing',
      name: 'BlockingCrossing',
      labelText: `${context} is blocking a crossing, fire exit or doorway`,
      subtext: '',
      buttonRef: null,
    },
    {
      id: 'BlockingRoad',
      name: 'BlockingRoad',
      labelText: `${context} is blocking the road or pavement`,
      subtext: '',
      buttonRef: null,
    },
    {
      id: 'OvercrowdedParkingBay',
      name: 'OvercrowdedParkingBay',
      labelText: `${context} is left at an overcrowded parking bay`,
      subtext: '',
      buttonRef: null,
    },
    {
      id: 'SomethingElse',
      name: 'SomethingElse',
      labelText: "It's something else",
      subtext: '',
      buttonRef: null,
    },
  ];
  const optionsWithDefault = options.map((option) => {
    return { ...option, isDefault: option.id === obstructionType };
  });

  const handleOnChange = (result: string) => {
    setErrorMessages([]);
    const resultId = options.find((option) => option.labelText === result);
    const issueType = resultId?.id;
    updateObstructionType(issueType ?? '');

    // update slaText according to bikesType and issueType
    if (bikesType === BikesType.HireBikes) {
      // @ts-ignore
      const getSlaText = HireBikesSlaTexts[issueType];
      updateSlaText(getSlaText);
    } else if (bikesType === BikesType.HireScooters) {
      // @ts-ignore
      const getSlaText = HireScootersSlaTexts[issueType];
      updateSlaText(getSlaText);
    }
  };

  const handlePreviousClick = () => {
    if (bikesType === BikesType.Bikes) {
      navigate(RoutesList.BIKES_LOCATION);
    } else {
      navigate(RoutesList.WHAT_HIRE_COMPANY);
    }
  };

  const handleNextClick = () => {
    if (!obstructionType) {
      const error = {
        path: errorPath,
        message: 'Select an option to continue',
      };
      setErrorMessages([error]);
      return;
    }
    navigate(RoutesList.TELL_US_MORE);
  };

  const buttonPrevious = {
    onClick: handlePreviousClick,
  };

  const buttonNext = {
    onClick: handleNextClick,
  };

  return (
    <BinaryQuestionTemplate
      title={title}
      errorPath={errorPath}
      errorMessages={errorMessages}
      onChange={handleOnChange}
      options={optionsWithDefault}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
